/**
 * Cleans up scroll-blocking DOM state before navigating away.
 * Prevents bfcache from preserving overflow: hidden and scroll-locking classes
 * when the user is redirected to an external payment page, cancels, and presses browser back.
 */
export const cleanupScrollLocks = () => {
  document.body.style.overflow = "";
  document.documentElement.classList.remove("is-modal-opened");
  document.documentElement.classList.remove("is-cart-drawer-opened");
};
